import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div className='loader-container'>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner
